<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title" v-if="packing_house_process">
      {{ module_name }}<span class="space-icon"></span
      ><i class="fa-solid fa-chevron-right fa-xs"></i
      ><span class="space-icon"></span>{{ packing_house_process.name
      }}<span class="space-icon"></span
      ><i class="fa-solid fa-chevron-right fa-xs"></i
      ><span class="space-icon"></span>{{ container_code }}
      <template v-if="brand_name">
        ({{ brand_name }})
      </template>
    </h1>
  </div>
</template>

<script>
export default {
  name: "AEProductionUniqFinalPackingListContainerHeader",
  components: {},
  props: ["packing_house_process", "container_code", "brand_name"],
  created() {
    this.checkIfAuthenticated();
  },
};
</script>
